import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../utils/apiAuth"; // Mevcut api.js dosyasını import edin// Proje bilgilerini çeken async thunk

export const fetchProjectDetails = createAsyncThunk(
  "projectEdit/fetchProjectDetails",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/projects/${projectId}`, {});
      if (response.data.success) {
        return response.data.data; // Sadece "data" kısmını döndürüyoruz
      } else {
        return rejectWithValue("Proje bilgileri alınamadı.");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.massage || "Bir hata oluştu"
      );
    }
  }
);

// Proje görselini çeken async thunk
export const fetchProjectImage = createAsyncThunk(
  "projectEdit/fetchProjectImage",
  async (relatedId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/images/${relatedId}`, {
        headers: {
          accept: "application/json",
        },
      });
      if (response.data.success) {
        // data bir dizi, ilk elemanı alıyoruz (tek görsel varsayımıyla)
        const imageData = response.data.data[0] || null;
        return imageData ? imageData.content : null; // content değerini döndürüyoruz
      } else {
        return rejectWithValue("Görsel bilgileri alınamadı.");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Bir hata oluştu"
      );
    }
  }
);
// Proje görselini yükleyen async thunk
export const uploadProjectImage = createAsyncThunk(
  "projectEdit/uploadProjectImage",
  async ({ relatedId, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("relatedId", relatedId);
      formData.append("relatedType", "Project");
      formData.append("imageType", "Logo");
      formData.append("file", file);

      const response = await api.post("/images/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response.data.success
        ? response.data.data.content
        : rejectWithValue("Görsel yüklenemedi.");
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Bir hata oluştu"
      );
    }
  }
);
// Proje pozisyonlarını çek
export const fetchProjectPositions = createAsyncThunk(
  "projectEdit/fetchProjectPositions",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/positions/getPositionsByProjectId/${projectId}`
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Proje pozisyonları alınamadı."
      );
    }
  }
);

// Proje güncelleme async thunk
export const updateProject = createAsyncThunk(
  "projectEdit/updateProject",
  async ({ projectId, updateData }, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/projects/updateProject/${projectId}`, {
        title: updateData.name,
        definition: updateData.description,
        completed_percentage: updateData.completion,
      });
      console.log("updateProject response:", response.data);
      if (response.data.success) {
        return response.data.data;
      } else {
        return rejectWithValue("Proje güncellenemedi.");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Bir hata oluştu"
      );
    }
  }
);

// Yeni pozisyon ekleme thunk'ı
export const addPosition = createAsyncThunk(
  "projectEdit/addPosition",
  async ({ positions, projectId }, { rejectWithValue }) => {
    try {
      // Yeni request body şemasına uygun veri hazırlama
      const requestBody = {
        projectId: projectId.toString(),
        positions: positions.map((position) => ({
          positionName: position.title,
          expectations: position.techs.map((tech) => tech.name),
          positionType: position.type, // Düzeltildi: positionType yerine type
        })),
      };
      console.log("addPosition requestBody:", requestBody);
      // Tek bir API çağrısı
      const response = await api.post("/positions/addPosition", requestBody);
      console.log("addPosition response:", response.data);
      // Backend'den gelen yanıtın başarılı olduğunu kontrol et
      if (response.data.success) {
        // response.data.data'nın dizi olduğundan emin ol
        const data = Array.isArray(response.data.data)
          ? response.data.data
          : [response.data.data].filter(Boolean); // Tek obje ise diziye çevir
        return data;
      } else {
        return rejectWithValue(
          response.data.message || "Pozisyonlar eklenemedi."
        );
      }
    } catch (error) {
      console.error("addPosition error:", error); // Hata ayıklama için
      return rejectWithValue(
        error.response?.data?.message || "Pozisyon eklenirken bir hata oluştu"
      );
    }
  }
);

// Pozisyon silme thunk'ı
export const deletePosition = createAsyncThunk(
  "projectEdit/deletePosition",
  async (positionId, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/positions/${positionId}`);
      if (response.data.success) {
        return positionId;
      } else {
        return rejectWithValue("Pozisyon silinemedi.");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Pozisyon silinirken bir hata oluştu"
      );
    }
  }
);

// Proje düzenleme slice'ı
const projectEditSlice = createSlice({
  name: "projectEdit",
  initialState: {
    project: null,
    image: null,
    positions: [],
    loading: false,
    error: null,
    updateSuccess: false,
    addPositionSuccess: false,
  },
  reducers: {
    resetProjectEdit: (state) => {
      state.project = null;
      state.image = null;
      state.loading = false;
      state.error = null;
      state.updateSuccess = false;
      state.addPositionSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.project = action.payload;
      })
      .addCase(fetchProjectDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetchProjectImage
      .addCase(fetchProjectImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectImage.fulfilled, (state, action) => {
        state.loading = false;
        state.image = action.payload; // base64 formatında content
      })
      .addCase(fetchProjectImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Proje Görseli Yükleme
      .addCase(uploadProjectImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadProjectImage.fulfilled, (state, action) => {
        state.loading = false;
        state.image = action.payload;
      })
      .addCase(uploadProjectImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Proje Pozisyonları
      .addCase(fetchProjectPositions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectPositions.fulfilled, (state, action) => {
        state.loading = false;
        state.positions = action.payload;
      })
      .addCase(fetchProjectPositions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Proje Güncelleme
      .addCase(updateProject.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateProject.fulfilled, (state, action) => {
        state.loading = false;
        state.project = action.payload;
        state.updateSuccess = true;
      })
      .addCase(updateProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.updateSuccess = false;
      })
      // Pozisyon Ekleme
      .addCase(addPosition.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.addPositionSuccess = false;
      })
      .addCase(addPosition.fulfilled, (state, action) => {
        state.loading = false;
        state.positions = [...state.positions, ...action.payload]; //action.payload dönen pozisyon array'i ,
        state.addPositionSuccess = true; //yeni pozisyonları state.positions'a ekliyor
      })
      .addCase(addPosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.addPositionSuccess = false;
      })
      // Pozisyon Silme
      .addCase(deletePosition.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePosition.fulfilled, (state, action) => {
        state.loading = false;
        state.positions = state.positions.filter(
          (position) => position._id !== action.payload
        );
      })
      .addCase(deletePosition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetProjectEdit } = projectEditSlice.actions;
export default projectEditSlice.reducer;
